window.myCustomMethod = function plugin_load(){
    let link = window.location.href;
    link.split("&")
    let f_id = link.split("&")[1].split("=");
    let p_type = link.split("&")[2].split("=")[1].replace("%20", " ");
    let meta_element = {
      t_fabric_id : f_id[1],
      product_type : p_type   
    }
    console.log(window.location.href);
    const tailoriPluginObj = new tailoriPlugin({
      position: 'right',
      boxwidth: null,
      boxheight: null,
      fabricShow: true,
      defaultTheme: 'theme_A',
      styleUi:'rounded',
      productName : meta_element.product_type,
      isVendor: true,
      lookData : undefined,
      fabricId : meta_element.t_fabric_id,
      customerKey:'23582861448',
      serviceUrl :'https://tsaas.textronic.online',
      customerUrl : 'https://measure-api.textronic.online',
      measurement: true,
      email: 'pranjali@gmail.com',
      secretKey: '123',
      clientMail:'client@gmail.com'
     });

// ========================================
// SAVE TAILORI SUMMARY
// ========================================

window.tailoriSummaryData = {
    styleSummary: null,
    measurementSummary: null
};

// ========== FUNCTION TO SAVE COMBINED SUMMARY ==========
function saveCombinedSummary() {
    const styleData = localStorage.getItem("tailori_style_summary");
    const measureData = localStorage.getItem("tailori_measurement_summary");
    
    let combined = {};
    
    if (styleData) {
        try {
            Object.assign(combined, JSON.parse(styleData));
        } catch (e) {
            console.error("Error parsing style data:", e);
        }
    } else {
        combined.ProductSummary = [];
        combined.ContrastSummary = [];
        combined.MonogramSummary = [];
        combined.FabricSummary = [];
        combined.TotalPrice = 0;
    }
    
    if (measureData) {
        try {
            const parsedMeasure = JSON.parse(measureData);
            combined.measurements = parsedMeasure.measurements || parsedMeasure;
        } catch (e) {
            console.error("Error parsing measurement data:", e);
            combined.measurements = {};
        }
    } else {
        combined.measurements = {};
    }
    
    combined.timestamp = new Date().toISOString();
    localStorage.setItem("summarydata", JSON.stringify(combined));
    console.log("summarydata saved");
}

// STYLE COMPLETE
tailoriPluginObj.on("styleComplete", function (styleData) {
    console.log("STYLE COMPLETE RAW:", styleData);

    try {
        // Some integrations return JSON text instead of an object.
        const raw =
            typeof styleData === "string"
                ? JSON.parse(styleData)
                : styleData;

        if (!raw || typeof raw !== "object") {
            console.error("Tailori returned no usable style object.");
            return;
        }

        // Preserve the complete event payload before selecting fields.
        localStorage.setItem(
            "tailori_style_raw",
            JSON.stringify(raw)
        );

        let summary = raw.summaryData ?? raw;

        if (typeof summary === "string") {
            summary = JSON.parse(summary);
        }

        if (!summary || typeof summary !== "object") {
            console.error("Invalid summaryData:", summary);
            return;
        }

        window.tailoriSummaryData =
            window.tailoriSummaryData || {};

        window.tailoriSummaryData.styleSummary = summary;

        // Save every field, not just five assumed fields.
        localStorage.setItem(
            "tailori_style_summary",
            JSON.stringify(summary)
        );

        saveCombinedSummary();

        console.log(
            "STYLE SUMMARY SAVED:",
            JSON.stringify(summary, null, 2)
        );
    } catch (error) {
        console.error("Could not capture Tailori style summary:", error);
    }
});
console.log(styleData)

// MEASUREMENT COMPLETE
tailoriPluginObj.on('measurementComplete', function(measureData) {
    console.log("MEASUREMENT COMPLETE:", measureData);
    window.tailoriSummaryData.measurementSummary = measureData;
    localStorage.setItem("tailori_measurement_summary", JSON.stringify(measureData));
    saveCombinedSummary();
});
console.log(measureData)
window.tailoriPluginObj = tailoriPluginObj;
console.log(tailoriPluginObj);
}

// ========================================
// POPUP FUNCTIONS
// ========================================
function closeCustomizationPopup() {
    const overlay = document.getElementById('customizationPopupOverlay');
    if (overlay) {
        overlay.remove();
        document.body.style.overflow = '';
    }
}

function openCustomizationPopup(customizationData) {
    closeCustomizationPopup();
    
    try {
        const data = typeof customizationData === 'string' ? JSON.parse(customizationData) : customizationData;
        
        if (!data) {
            alert('No customization data available');
            return;
        }
        
        let html = `
        <div class="customization-popup-overlay" id="customizationPopupOverlay" onclick="if(event.target===this)closeCustomizationPopup()">
            <div class="customization-popup-content">
                <div class="customization-popup-header">
                    <h2>Customization Details</h2>
                    <button class="customization-popup-close" onclick="closeCustomizationPopup()">×</button>
                </div>
                <div class="customization-popup-body">
        `;
        
        // Style Summary
        if (data.ProductSummary && data.ProductSummary.length > 0) {
            html += `<div class="customization-section"><h3>Style Selections</h3><table class="customization-table"><thead><tr><th>Product</th><th>Option</th><th>Feature</th><th>Price</th></tr></thead><tbody>`;
            data.ProductSummary.forEach(item => {
                html += `<tr><td>${item.Product || ''}</td><td>${item.Option || ''}</td><td>${item.Feature || ''}</td><td>₹${item.Price || 0}</td></tr>`;
            });
            html += `</tbody></table></div>`;
        }
        
        // Fabric Summary
        if (data.FabricSummary && data.FabricSummary.length > 0) {
            html += `<div class="customization-section"><h3>Fabric Details</h3><table class="customization-table"><thead><tr><th>Fabric Name</th><th>Price</th></tr></thead><tbody>`;
            data.FabricSummary.forEach(item => {
                html += `<tr><td>${item.Name || ''}</td><td>₹${item.Price || 0}</td></tr>`;
            });
            html += `</tbody></table></div>`;
        }
        
        // Measurements
        if (data.measurements && Object.keys(data.measurements).length > 0) {
            html += `<div class="customization-section"><h3>Measurements</h3><table class="customization-table"><thead><tr><th>Measurement</th><th>Value</th></tr></thead><tbody>`;
            Object.keys(data.measurements).forEach(key => {
                const value = data.measurements[key];
                const formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                html += `<tr><td>${formattedKey}</td><td>${value}</td></tr>`;
            });
            html += `</tbody></table></div>`;
        }
        
        // Total Price
        if (data.TotalPrice !== undefined) {
            html += `<div class="customization-total"><h3>Total Customization Cost: ₹${data.TotalPrice}</h3></div>`;
        }
        
        html += `</div></div></div>`;
        
        document.body.insertAdjacentHTML('beforeend', html);
        document.body.style.overflow = 'hidden';
        
    } catch (e) {
        console.error('Error showing popup:', e);
        alert('Error showing customization details');
    }
}

// ========================================
// ADD VIEW BUTTON TO CART
// ========================================
function addViewDetailsButtonToCart() {
    document.querySelectorAll('.cart-item, .cart__item, .cart-row').forEach(function(item) {
        if (item.querySelector('.view-customization-btn')) return;
        
        const properties = item.querySelectorAll('.cart-item__property, .cart-attribute');
        let customizationData = null;
        
        properties.forEach(function(prop) {
            const label = prop.querySelector('.cart-item__property-label, .cart-attribute-label');
            if (label && label.textContent.trim() === 'Customization Summary') {
                const value = prop.querySelector('.cart-item__property-value, .cart-attribute-value');
                if (value) {
                    customizationData = value.textContent.trim();
                }
            }
        });
        
        if (customizationData) {
            const btn = document.createElement('button');
            btn.textContent = '👁️ View Customization';
            btn.className = 'view-customization-btn';
            btn.style.cssText = 'background:#3b82f6;color:#fff;border:none;padding:6px 14px;border-radius:6px;cursor:pointer;font-size:12px;margin-top:8px;';
            btn.onclick = function() {
                openCustomizationPopup(customizationData);
            };
            
            const priceElement = item.querySelector('.cart-item__price, .cart__price');
            if (priceElement) {
                priceElement.parentNode.insertBefore(btn, priceElement.nextSibling);
            } else {
                item.appendChild(btn);
            }
        }
    });
}

// Run on cart page
if (document.querySelector('.cart, .cart-wrapper, .cart-page')) {
    setTimeout(addViewDetailsButtonToCart, 1000);
}

// ========================================
// REST OF YOUR CODE (NO CHANGES)
// ========================================
$(document).ready(function () {
    $(".tdsStyle").addClass("client1");
    
    function tailori_singleProduct(product_item_id) {
        fetch(`https://shopify.textronic.in/fab3d.php?PRODUCT=${product_item_id}`)
            .then((response) => response.text())
            .then((result) => {
                var meta = JSON.parse(result);
                meta.data.product.metafields.edges.forEach(function (element, num) {
                    if (element.node.key == "tailori_fabric_id") {
                        window.productDetails.tailori_fabric_id = element.node.value;
                    }
                    if (element.node.key == "product") {
                        window.productDetails.product = element.node.value;
                    }
                    if (element.node.key == "product_type") {
                        window.productDetails.product_type = element.node.value;
                    }
                });
                $(".t_customization").removeAttr("disabled")
            })
            .catch((error) => console.error(error));
    }

    if (tailori_templete === "tailori_prduct_page") {
        let product_item_id = window.productDetails.id;
        tailori_singleProduct(product_item_id);
    }

    async function tailori_collection_data(collection_id) {
        try {
            const response = await fetch(`https://shopify.textronic.in/fab3d.php?COLLECTION=${collection_id}`);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const t_response = await response.json();
            
            var tailor_colection_info = []
            globalThis.tailor_colection_info = tailor_colection_info;
            const product_data = {};
            t_response.data.collection.products.edges.forEach(function(element, num) {
                let p_id = element.node.id.split("/")[4];
                product_data.p_id = p_id ;
                element.node.metafields.edges.forEach(function(element, num) {
                    if (element.node.key == "tailori_fabric_id") {
                        product_data.tailori_fabric_id = element.node.value;
                    }
                    if (element.node.key == "product") {
                        product_data.t_product = element.node.value;
                    }
                    if (element.node.key == "product_type") {
                        product_data.t_product_type = element.node.value;
                    }
                });
                let newProductData = { ...product_data };
                globalThis.tailor_colection_info.push(newProductData);
            });
            return;
        } catch (error) {
            console.error("There has been a problem with your fetch operation:", error);
        }
    }
  
    if (tailori_templete === "tailori_collection_page") {
        let collection_id = window.productDetails.id
        tailori_collection_data(collection_id);
        $(".initTryon").each(function () {
            $(this).css("display", "none");
        });
    }
  
    $("body").on("click", ".tailori_collection_btn, .t_customization", handleTailoriButtonClick);

    


});
function handleTailoriButtonClick(event) {
    debugger
    event.preventDefault();
    const $btn = $(this);
    
    let productId, variantId;
    let t_product_data = {};
    
    // ========================================
    // Try to get from button attributes first
    // ========================================
    if ($btn.attr('pid') && $btn.attr('data-variant-id')) {
        productId = $btn.attr('pid');
        variantId = $btn.attr('data-variant-id');
        console.log("Got data from button attributes");
    } else {
        // ========================================
        // Get from URL/window for t_customization
        // ========================================
        console.log("Getting data from page");
        
        // Get productId
        productId = window.productDetails?.id || 
                   window.Product?.id || 
                   getProductIdFromURL();
        
        // Get variantId
        const urlParams = new URLSearchParams(window.location.search);
        variantId = urlParams.get('variant') || 
                   window.productDetails?.selectedVariantId || 
                   window.productDetails?.variants?.[0]?.id ||
                   document.querySelector('[name="id"]')?.value || '';
    }
    
    // ========================================
    // Find product data
    // ========================================
    if (window.tailor_colection_info) {
        for (const element of window.tailor_colection_info) {
            if (productId === element.p_id) {
                t_product_data = {
                    id: element.p_id,
                    tailori_fabric_id: element.tailori_fabric_id,
                    product: element.t_product,
                    product_type: element.t_product_type
                };
                break;
            }
        }
    }
    
    // Fallback to window.productDetails
    if (Object.keys(t_product_data).length === 0 && window.productDetails) {
        t_product_data = {
            id: productId,
            tailori_fabric_id: window.productDetails.tailori_fabric_id || '',
            product: window.productDetails.product || window.productDetails.title || '',
            product_type: window.productDetails.product_type || window.productDetails.type || ''
        };
    }
    
    console.log("Product Data:", { productId, variantId, t_product_data });
    
    if (productId && variantId && t_product_data.tailori_fabric_id) {
        openTailoriCustomization(productId, variantId, t_product_data);
    } else {
        alert("Unable to get product information. Please try again.");
    }

    // const fabricInfo = document.getElementById('tailori-wrapper')
    //                     ?.getAttribute('data-fabric-info') || '';
    // if (fabricInfo) {
    //     localStorage.setItem('fabricInfo', fabricInfo);
    // }

 const wrapper = document.getElementById('tailori-wrapper');

  const fabricInfo = wrapper?.getAttribute('data-fabric-info') || '';
  if (fabricInfo) localStorage.setItem('fabricInfo', fabricInfo);

  const productImage = wrapper?.getAttribute('data-product-image') || '';
  if (productImage) localStorage.setItem('fabricImageUrl', productImage);

  const productTitle = wrapper?.getAttribute('data-product-title') || '';
  if (productTitle) localStorage.setItem('fabricTitle', productTitle);

}

// Helper function to get product ID from URL
function getProductIdFromURL() {
    // Try to get from Shopify's product data
    if (window.Product) return window.Product.id;
    if (window.productDetails) return window.productDetails.id;
    
    // Try to get from meta tags
    const metaTag = document.querySelector('meta[property="og:url"]');
    if (metaTag) {
        const url = metaTag.getAttribute('content');
        const match = url.match(/\/products\/([^\/?]+)/);
        if (match) {
            // You might need to map handle to ID
            return match[1];
        }
    }
    
    return '';
}
function openTailoriCustomization(productId, variantId, productData) {
    console.log("Product ID:", productId);
    console.log("Variant ID:", variantId);
    console.log("Product Data:", productData);

    if (!variantId) {
        alert("Variant ID not found.");
        return;
    }

    window.location.href =
        `https://mj2fn4-rw.myshopify.com/pages/customization/` +
        `&f_id=${encodeURIComponent(productData.tailori_fabric_id)}` +
        `&p_type=${encodeURIComponent(productData.product_type)}` +
        `&p_id=${encodeURIComponent(productId)}` +
        `&variant_id=${encodeURIComponent(variantId)}`;
}


$(".initTryon").each(function () {
    $(this).css("display", "none");
});

$(document).ready(function () {
    const path = window.location.pathname;
    if (path.startsWith("/pages/customization/")) {
        $('#shopify-section-sections--25658210943343__header').css("display", "none");
        $('.section-header').css("display", "none");
    }
  
});



$(document).on("click", "#cartbtIn", async function (event) {
    event.preventDefault();

    const link = window.location.href;

    // ========================================
    // GET VARIANT ID
    // ========================================
    let variantId = null;

    link.split("&").forEach(function(part) {
        if (part.startsWith("variant_id=")) {
            variantId = part.split("=")[1].split("#")[0].trim();
        }
    });

    console.log("Raw Variant ID:", variantId);

    if (!variantId || !/^\d+$/.test(variantId)) {
        console.error("Invalid Variant ID:", variantId);
        alert("Variant ID not found.");
        return;
    }

    // ========================================
    // CHECK IF PROFILE IS SELECTED
    // ========================================
    let selectedMeasurement = null;
    let activeProfile = document.querySelectorAll('.boxBorder.box-active');
    
    if (activeProfile.length > 0) {
        console.log("Active profile found");
        
        try {
            // Check if mTom_Plugin exists
            if (typeof mTom_Plugin !== 'undefined') {
                // Get the selected profile from mTom_Plugin
                let selectedProfile = await mTom_Plugin.getSelectedProfile();
                console.log("Selected Profile:", selectedProfile);
                
                if (selectedProfile && selectedProfile.profile && selectedProfile.profile.profile_id) {
                    // Get measurement data for the selected profile
                    let customerMeasurement = await mTom_Plugin.getMeasurementdata(selectedProfile.profile.profile_id);
                    console.log("Customer Measurement:", customerMeasurement);
                    
                    // Get summary data from localStorage
                    let summarydata = null;
                    try {
                        const savedSummary = localStorage.getItem("summarydata");
                        if (savedSummary) {
                            summarydata = JSON.parse(savedSummary);
                        }
                    } catch (e) {
                        console.error("Error parsing summarydata:", e);
                    }
                    
                    // Add summary to measurement data
                    customerMeasurement.summary = summarydata;
                    selectedMeasurement = customerMeasurement;
                    
                    console.log("Final selectedMeasurement:", selectedMeasurement);
                } else {
                    alert("Could not get profile ID. Please try again.");
                    return;
                }
            } else {
                alert("Measurement plugin not available. Please try again.");
                return;
            }
        } catch (error) {
            console.error("Error getting measurement data:", error);
            alert("Error fetching measurement data. Please try again.");
            return;
        }
    } else {
        // No profile selected
        alert("Please select a measurement profile first!");
        console.error("No active profile found");
        return;
    }

    // ========================================
    // VALIDATE: Measurement data must exist
    // ========================================
    if (!selectedMeasurement) {
        alert("Could not fetch measurement data. Please try again.");
        console.error("No measurement data available");
        return;
    }

    // ========================================
    // CREATE SHOPIFY PROPERTIES
    // ========================================
    const properties = {};

    // ========================================
    // SECTION 1: MEASUREMENT SUMMARY
    // ========================================
    if (selectedMeasurement && selectedMeasurement.measurementData) {
        const measurementData = selectedMeasurement.measurementData;
        
        // Add a header for measurement section
        properties["=== MEASUREMENT SUMMARY ==="] = "";
        
        // Add all measurement fields with original key names
        Object.keys(measurementData).forEach(function(key) {
            const value = measurementData[key];
            if (value !== null && value !== undefined && value !== "") {
                properties[key] = value;
            }
        });
    }

    // ========================================
    // SECTION 2: STYLE/CUSTOMIZATION SUMMARY
    // ========================================
    let summary = null;
    try {
        const savedSummary = localStorage.getItem("summarydata");
        alert(summaryData)
        if (savedSummary) {
            summary = JSON.parse(savedSummary);
        }
    } catch (error) {
        console.error("Error parsing summarydata:", error);
    }

    let styleData = null;
    try {
        const savedStyle = localStorage.getItem("tailori_style_summary");
        if (savedStyle) {
            styleData = JSON.parse(savedStyle);
        }
    } catch (error) {
        console.error("Error parsing style data:", error);
    }

    // Add header for style summary section
    properties["=== STYLE SUMMARY ==="] = "";

    const summarySource = summary || styleData;
    
    if (summarySource) {
        // Product Summary
        if (summarySource.ProductSummary && Array.isArray(summarySource.ProductSummary)) {
            summarySource.ProductSummary.forEach(function(item) {
                if (item.Product && item.Feature) {
                    properties[item.Product] = item.Feature;
                }
            });
        }

        // Contrast Summary
        if (summarySource.ContrastSummary && Array.isArray(summarySource.ContrastSummary)) {
            summarySource.ContrastSummary.forEach(function(item) {
                if (item.Product && item.Feature) {
                    properties[item.Product] = item.Feature;
                }
            });
        }

        // Monogram Summary
        if (summarySource.MonogramSummary && Array.isArray(summarySource.MonogramSummary)) {
            summarySource.MonogramSummary.forEach(function(item) {
                if (item.Product && item.Feature) {
                    properties[item.Product] = item.Feature;
                }
            });
        }

        // Fabric Summary
        if (summarySource.FabricSummary && Array.isArray(summarySource.FabricSummary)) {
            summarySource.FabricSummary.forEach(function(item) {
                if (item.Name) {
                    properties["Fabric"] = item.Name;
                }
            });
        }

        // Total Price
        if (summarySource.TotalPrice !== undefined && summarySource.TotalPrice !== null) {
            properties["Total Price"] = `₹${summarySource.TotalPrice}`;
        }
    }

    console.log("FINAL SHOPIFY PROPERTIES:", properties);

    // ========================================
    // ADD PRODUCT TO CART
    // ========================================
    try {
        const cartItems = {
            items: [
                {
                    id: parseInt(variantId, 10),
                    quantity: 1,
                    properties: properties
                }
            ]
        };

        console.log("Sending to Shopify:", cartItems);

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(cartItems)
        });

        const data = await response.json();
        console.log("Cart response:", data);

        if (!response.ok) {
            console.error("Shopify cart error:", data);
            alert(data.description || "Unable to add product to cart.");
            return;
        }

        console.log("Product added successfully with measurement data!");
        window.location.href = "/cart";

    } catch (error) {
        console.error("Add to cart error:", error);
        alert("Unable to add product to cart.");
    }
});
// ========================================
// CSS FOR POPUP (Added dynamically)
// ========================================
(function addPopupStyles() {
    if (document.getElementById('tailori-popup-styles')) return;
    
    const styles = document.createElement('style');
    styles.id = 'tailori-popup-styles';
    styles.textContent = `
        .customization-popup-overlay {
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0,0,0,0.7); z-index: 999999;
            display: flex; justify-content: center; align-items: center;
        }
        .customization-popup-content {
            background: #fff; border-radius: 12px; max-width: 800px; width: 90%;
            max-height: 80vh; display: flex; flex-direction: column;
            box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        }
        .customization-popup-header {
            padding: 20px 24px; border-bottom: 1px solid #e5e7eb;
            display: flex; justify-content: space-between; align-items: center;
        }
        .customization-popup-header h2 { margin: 0; font-size: 20px; }
        .customization-popup-close {
            background: none; border: none; font-size: 28px;
            cursor: pointer; color: #6b7280;
        }
        .customization-popup-close:hover { color: #ef4444; }
        .customization-popup-body { padding: 24px; overflow-y: auto; flex: 1; }
        .customization-section { margin-bottom: 24px; }
        .customization-section h3 {
            font-size: 16px; font-weight: 600; margin: 0 0 12px 0;
            padding-bottom: 8px; border-bottom: 2px solid #f3f4f6;
        }
        .customization-table { width: 100%; border-collapse: collapse; font-size: 14px; }
        .customization-table thead th {
            background: #f9fafb; text-align: left; padding: 10px 12px;
            font-weight: 600; border-bottom: 2px solid #e5e7eb;
        }
        .customization-table tbody td {
            padding: 8px 12px; border-bottom: 1px solid #f3f4f6;
        }
        .customization-total {
            margin-top: 20px; padding-top: 16px;
            border-top: 2px solid #e5e7eb; text-align: right;
        }
        .customization-total h3 { font-size: 18px; font-weight: 700; }
        .view-customization-btn {
            background: #3b82f6; color: #fff; border: none;
            padding: 6px 14px; border-radius: 6px; cursor: pointer;
            font-size: 12px; margin-top: 8px;
        }
        .view-customization-btn:hover { background: #2563eb; }
    `;
    document.head.appendChild(styles);
})();

// Run on cart page to add view buttons
if (document.querySelector('.cart, .cart-wrapper, .cart-page')) {
    setTimeout(addViewDetailsButtonToCart, 1500);
}

function addFloatingCustomizationButton() {
    // Check if button already exists
    if (document.getElementById('floatingCustomizationBtn')) return;
    
    // Check if customization data exists
    const summaryData = localStorage.getItem('summarydata');
    let summary = null;
    if (!summaryData) {
        console.log('No customization data available');
        return;
    }
    
    // Create the floating button
    const btn = document.createElement('button');
    btn.id = 'floatingCustomizationBtn';
    btn.innerHTML = '👁️ View Customization';
    btn.style.cssText = `
        position: fixed;
        bottom: 30px;
        right: 30px;
        background: linear-gradient(135deg, #3b82f6, #2563eb);
        color: #ffffff;
        border: none;
        padding: 14px 28px;
        border-radius: 50px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
        z-index: 999999;
        box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    `;
    
    // Hover effects
    btn.onmouseenter = function() {
        this.style.transform = 'scale(1.05)';
        this.style.boxShadow = '0 6px 25px rgba(59, 130, 246, 0.6)';
        this.style.background = 'linear-gradient(135deg, #2563eb, #1d4ed8)';
    };
    
    btn.onmouseleave = function() {
        this.style.transform = 'scale(1)';
        this.style.boxShadow = '0 4px 15px rgba(59, 130, 246, 0.4)';
        this.style.background = 'linear-gradient(135deg, #3b82f6, #2563eb)';
    };
    
    // Click handler
    btn.onclick = function() {
        const data = localStorage.getItem('summarydata');
        if (data) {
            try {
                const parsed = JSON.parse(data);
                if (parsed.ProductSummary && parsed.ProductSummary.length > 0) {
                    openCustomizationPopup(data);
                } else {
                    alert('No customization data available');
                }
            } catch(e) {
                alert('Error reading customization data');
            }
        } else {
            alert('No customization data available');
        }
    };
    
    // Add to page
    document.body.appendChild(btn);
    console.log('Floating customization button added');
}

// ///////////////////////////////////
// ========================================
// SHOW MEASUREMENT DATA ONLY
// ========================================
function showMeasurementData() {
    try {
        const measureData = localStorage.getItem("tailori_measurement_summary");
        if (!measureData) {
            alert('No measurement data available. Please complete your measurements first.');
            return;
        }
        
        const data = JSON.parse(measureData);
        
        let html = `
        <div class="customization-popup-overlay" id="customizationPopupOverlay" onclick="if(event.target===this)closeCustomizationPopup()">
            <div class="customization-popup-content">
                <div class="customization-popup-header">
                    <h2>📏 Measurement Details</h2>
                    <button class="customization-popup-close" onclick="closeCustomizationPopup()">×</button>
                </div>
                <div class="customization-popup-body">
        `;
        
        // Check if measurements exist
        const measurements = data.measurements || data;
        
        if (Object.keys(measurements).length > 0) {
            html += `<div class="customization-section">
                        <h3>Your Measurements</h3>
                        <table class="customization-table">
                            <thead>
                                <tr><th>Measurement</th><th>Value</th></tr>
                            </thead>
                            <tbody>`;
            
            Object.keys(measurements).forEach(key => {
                const value = measurements[key];
                if (value !== null && value !== undefined && value !== "") {
                    const formattedKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                    html += `<tr><td>${formattedKey}</td><td>${value}</td></tr>`;
                }
            });
            
            html += `</tbody></table></div>`;
        } else {
            html += `<p>No measurement data found.</p>`;
        }
        
        // Show profile info if available
        if (data.profile_name) {
            html += `<div class="customization-section">
                        <h3>Profile Information</h3>
                        <p><strong>Profile:</strong> ${data.profile_name}</p>
                        ${data.profile_id ? `<p><strong>Profile ID:</strong> ${data.profile_id}</p>` : ''}
                    </div>`;
        }
        
        html += `</div></div></div>`;
        
        document.body.insertAdjacentHTML('beforeend', html);
        document.body.style.overflow = 'hidden';
        
    } catch (e) {
        console.error('Error showing measurement data:', e);
        alert('Error showing measurement data');
    }
}

// ========================================
// SHOW STYLE DATA ONLY
// ========================================
function showStyleData() {
    try {
        // Try to get combined summary first
        let styleData = localStorage.getItem("summarydata");
        if (styleData) {
            const parsed = JSON.parse(styleData);
            // Check if it has style data
            if (parsed.ProductSummary && parsed.ProductSummary.length > 0) {
                displayStylePopup(parsed);
                return;
            }
        }
        
        // If not found in summarydata, try style summary
        styleData = localStorage.getItem("tailori_style_summary");
        if (styleData) {
            const parsed = JSON.parse(styleData);
            displayStylePopup(parsed);
            return;
        }
        
        alert('No style data available. Please complete your style customization first.');
        
    } catch (e) {
        console.error('Error showing style data:', e);
        alert('Error showing style data');
    }
}

// ========================================
// DISPLAY STYLE POPUP (Helper function)
// ========================================
function displayStylePopup(data) {
    let html = `
    <div class="customization-popup-overlay" id="customizationPopupOverlay" onclick="if(event.target===this)closeCustomizationPopup()">
        <div class="customization-popup-content">
            <div class="customization-popup-header">
                <h2>👕 Style Customization Details</h2>
                <button class="customization-popup-close" onclick="closeCustomizationPopup()">×</button>
            </div>
            <div class="customization-popup-body">
    `;
    
    // Product Summary
    if (data.ProductSummary && data.ProductSummary.length > 0) {
        html += `<div class="customization-section">
                    <h3>🎨 Product Selections</h3>
                    <table class="customization-table">
                        <thead>
                            <tr><th>Product</th><th>Option</th><th>Feature</th><th>Price</th></tr>
                        </thead>
                        <tbody>`;
        
        data.ProductSummary.forEach(item => {
            html += `<tr>
                        <td>${item.Product || ''}</td>
                        <td>${item.Option || ''}</td>
                        <td>${item.Feature || ''}</td>
                        <td>₹${item.Price || 0}</td>
                    </tr>`;
        });
        
        html += `</tbody></table></div>`;
    }
    
    // Contrast Summary
    if (data.ContrastSummary && data.ContrastSummary.length > 0) {
        html += `<div class="customization-section">
                    <h3>🎨 Contrast Selections</h3>
                    <table class="customization-table">
                        <thead>
                            <tr><th>Product</th><th>Feature</th><th>Price</th></tr>
                        </thead>
                        <tbody>`;
        
        data.ContrastSummary.forEach(item => {
            html += `<tr>
                        <td>${item.Product || ''}</td>
                        <td>${item.Feature || ''}</td>
                        <td>₹${item.Price || 0}</td>
                    </tr>`;
        });
        
        html += `</tbody></table></div>`;
    }
    
    // Monogram Summary
    if (data.MonogramSummary && data.MonogramSummary.length > 0) {
        html += `<div class="customization-section">
                    <h3>🔤 Monogram Details</h3>
                    <table class="customization-table">
                        <thead>
                            <tr><th>Product</th><th>Feature</th><th>Price</th></tr>
                        </thead>
                        <tbody>`;
        
        data.MonogramSummary.forEach(item => {
            html += `<tr>
                        <td>${item.Product || ''}</td>
                        <td>${item.Feature || ''}</td>
                        <td>₹${item.Price || 0}</td>
                    </tr>`;
        });
        
        html += `</tbody></table></div>`;
    }
    
    // Fabric Summary
    if (data.FabricSummary && data.FabricSummary.length > 0) {
        html += `<div class="customization-section">
                    <h3>🧵 Fabric Details</h3>
                    <table class="customization-table">
                        <thead>
                            <tr><th>Fabric Name</th><th>Price</th></tr>
                        </thead>
                        <tbody>`;
        
        data.FabricSummary.forEach(item => {
            html += `<tr>
                        <td>${item.Name || ''}</td>
                        <td>₹${item.Price || 0}</td>
                    </tr>`;
        });
        
        html += `</tbody></table></div>`;
    }
    
    // Total Price
    if (data.TotalPrice !== undefined && data.TotalPrice !== null) {
        html += `<div class="customization-total">
                    <h3>💰 Total Customization Cost: ₹${data.TotalPrice}</h3>
                </div>`;
    }
    
    // Timestamp if available
    if (data.timestamp) {
        html += `<div style="text-align:right;font-size:12px;color:#999;margin-top:10px;">
                    Last updated: ${new Date(data.timestamp).toLocaleString()}
                </div>`;
    }
    
    html += `</div></div></div>`;
    
    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';
}

// ========================================
// SHOW BOTH MEASUREMENT AND STYLE
// ========================================
function showFullCustomizationData() {
    try {
        const summaryData = localStorage.getItem("summarydata");
        if (summaryData) {
            openCustomizationPopup(summaryData);
        } else {
            // Try to combine both separately
            const styleData = localStorage.getItem("tailori_style_summary");
            const measureData = localStorage.getItem("tailori_measurement_summary");
            
            if (!styleData && !measureData) {
                alert('No customization data available.');
                return;
            }
            
            let combined = {};
            
            if (styleData) {
                Object.assign(combined, JSON.parse(styleData));
            }
            
            if (measureData) {
                const parsedMeasure = JSON.parse(measureData);
                combined.measurements = parsedMeasure.measurements || parsedMeasure;
            }
            
            if (Object.keys(combined).length > 0) {
                openCustomizationPopup(combined);
            } else {
                alert('No data available to display.');
            }
        }
    } catch (e) {
        console.error('Error showing full data:', e);
        alert('Error displaying data');
    }
}

//calling all methods
tailoriPlugin.prototype.getStyles = function(){
  return window.pluginObj.getStyles();
}
tailoriPlugin.prototype.getProductName = function(){
  return window.pluginObj.getProductName();
}
tailoriPlugin.prototype.getAlignments = function(){
  return window.pluginObj.getAlignments();
}
tailoriPlugin.prototype.onChangeTexture = function(fabId){
  return window.pluginObj.onChangeTexture(fabId);
}
tailoriPlugin.prototype.resetProduct = function(){
  return window.pluginObj.resetProduct();
}
tailoriPlugin.prototype.getBlockDetails = function(){
  return window.pluginObj.getBlockDetails();
}

// ===== Fabric =====
tailoriPlugin.prototype.getFabricData = function(){
  return window.pluginObj.getFabricData();
}
tailoriPlugin.prototype.doFilterSearch = function(filterObj){
  return window.pluginObj.doFilterSearch(filterObj);
}
tailoriPlugin.prototype.doTextSearch = function(searchString){
  return window.pluginObj.doTextSearch(searchString);
}
tailoriPlugin.prototype.getFeatures = function(){
  return window.pluginObj.getFeatures();
}
tailoriPlugin.prototype.getDesignInfo = function(parentId){
  return window.pluginObj.getDesignInfo(parentId);
}
tailoriPlugin.prototype.getModelDesignInfo = function(){
  return window.pluginObj.getModelDesignInfo();
}

// ===== Contrast =====
tailoriPlugin.prototype.getContrastData = function(){
  return window.pluginObj.getContrastData();
}
tailoriPlugin.prototype.getContrastFabrics = function(){
  return window.pluginObj.getContrastFabrics();
}
tailoriPlugin.prototype.onApplyContrastFabric = function(contrastFabricId){
  return window.pluginObj.onApplyContrastFabric(contrastFabricId);
}
tailoriPlugin.prototype.getInnerLinningData = function(){
  return window.pluginObj.getInnerLinningData();
}
tailoriPlugin.prototype.onLibConfigTexture = function(fabricId){
  return window.pluginObj.onLibConfigTexture(fabricId);
}

// ===== Buttons / Threads =====
tailoriPlugin.prototype.getButtonStyleData = function(){
  return window.pluginObj.getButtonStyleData();
}
tailoriPlugin.prototype.getButtonData = function(){
  return window.pluginObj.getButtonData();
}
tailoriPlugin.prototype.getButtonthreadHoleData = function(){
  return window.pluginObj.getButtonthreadHoleData();
}

// ===== Monogram =====
tailoriPlugin.prototype.getMonogramData = function(){
  return window.pluginObj.getMonogramData();
}

// ===== Summary / Cart =====
tailoriPlugin.prototype.getSummaryData = function(){
  return window.pluginObj.getSummaryData();
}
tailoriPlugin.prototype.LookUrl = function(){
  return window.pluginObj.LookUrl();
}
tailoriPlugin.prototype.LoadLook = function(){
  return window.pluginObj.LoadLook();
}
tailoriPlugin.prototype.saveLook = function(lookData){
  return window.pluginObj.saveLook(lookData);
}
// get fabric Info
// fabric info
console.log('Info button exists:', document.getElementById('infoBt'));

$(document).ready(function() {
    // First check if element exists
    if ($('#infoBt').length === 0) {
        console.log('⚠️ infoBt not found in DOM');
        // Wait for it
        const waitForBtn = setInterval(() => {
            if ($('#infoBt').length > 0) {
                console.log('✅ infoBt found!');
                clearInterval(waitForBtn);
                // Attach click
                $('#infoBt').on('click', function(e) {
                    e.preventDefault();
                    
                const fabricInfo = localStorage.getItem('fabricInfo') || '';

                if (!fabricInfo) {
                    alert('No fabric info available.');
                    return;
                }
                    showFabricInfo()
             
                });
            }
        }, 500);
    } else {
        // Element exists, attach click
        $('#infoBt').on('click', function(e) {
            e.preventDefault();
        
                const fabricInfo = localStorage.getItem('fabricInfo') || '';

                if (!fabricInfo) {
                    alert('No fabric info available.');
                    return;
                }
                showFabricInfo()
        });
        
    }
});

function showFabricInfo() {
  const fabricInfo = localStorage.getItem('fabricInfo') || '';
  const productImage = localStorage.getItem('fabricImageUrl') || '';
  const productTitle = localStorage.getItem('fabricTitle') || 'Fabric Information';
  $('#popup_fab').css({ 'display': 'block', 'left': '0px' });
  if (!fabricInfo) {
    alert('No fabric info available.');
    return;
  }

  // Set title
  document.getElementById('fabgetName').textContent = productTitle;

  // Set background image
  if (productImage) {
    document.querySelector('.fabric_view').style.backgroundImage = `url("${productImage}")`;
    document.querySelector('.fabric_view').style.backgroundSize = 'contain';
  }

  // Set description
  document.getElementById('descD').textContent = fabricInfo;

  // Clear & hide other fields
  document.getElementById('priceId').textContent = '';
  document.getElementById('blendD').textContent = '';
  document.getElementById('colourD').textContent = '';
  document.getElementById('brandD').textContent = '';
  document.getElementById('designPropertiesContainer').style.display = 'none';

  // Show popup
  $('#popup_fab').css({ 'display': 'block', 'left': '0px' });
}
//order generation
async function saveProductionDetails(cartItemKey, measurements, summary) {
  const root = window.Shopify?.routes?.root || "/";

  // Read the cart so existing item properties are preserved.
  const cartResponse = await fetch(`${root}cart.js`);
  if (!cartResponse.ok) {
    throw new Error("Could not load the cart.");
  }

  const cart = await cartResponse.json();
  const item = cart.items.find((item) => item.key === cartItemKey);

  if (!item) {
    throw new Error("This cart item was not found. Refresh the cart.");
  }

  const toText = (value) =>
    typeof value === "string" ? value : JSON.stringify(value);

  const response = await fetch(`${root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: item.key,
      quantity: item.quantity,
      properties: {
        ...(item.properties || {}),
        "Measurements": toText(measurements),
        "Customization summary": toText(summary)
      }
    })
  });

  if (!response.ok) {
    throw new Error("Could not save the production details.");
  }

  // Properties can change the item's key. Use the returned cart afterwards.
  return response.json();
}
